<template>
  <div class="q-pa-md q-gutter-sm">
    <q-btn
      label="Filtros"
      no-caps
      icon="filter_alt"
      color="primary"
      @click="abrirModal = true"
    />

    <q-dialog
      v-model="abrirModal"
      :persistent="persistent"
      transition-show="scale"
      transition-hide="scale"
    >
      <q-card style="width: 900px; max-width: 90vw">
        <div class="bg-brand-1 text-white">
          <q-card-section>
            <div class="text-h6">
              Filtros do Relatório de Vínculos Requisição
            </div>
          </q-card-section>

          <q-card-section class="q-pt-none">
            Selecione os filtros desejados e clique em 'Filtrar' para carregar
            os dados.
          </q-card-section>
        </div>

        <q-card-section class="filtros-section">
          <div class="row q-col-gutter-md">
            <div class="col-12 col-md-6">
              <div class="text-brand-5 text-weight-bold q-mb-sm">Unidade</div>
              <q-select
                dense
                outlined
                v-model="filtros.unidade"
                :options="optionsUnidade"
                option-label="label"
                option-value="id"
                emit-value
                map-options
                label="Selecione a unidade"
              />
            </div>

            <div class="col-12 col-md-6">
              <div class="text-brand-5 text-weight-bold q-mb-sm">
                Número do Contrato
              </div>
              <q-input
                dense
                outlined
                v-model="filtros.numeroContrato"
                placeholder="Digite o número do contrato"
              />
            </div>

            <div class="col-12 col-md-6">
              <div class="text-brand-5 text-weight-bold q-mb-sm">
                Data Inicial
              </div>
              <q-input
                dense
                outlined
                placeholder="DD/MM/AAAA"
                v-model="filtros.dataInicial"
                mask="##/##/####"
                :rules="[(val) => validarDataEmissao(val) || 'Data Inválida']"
              >
                <template v-slot:append>
                  <q-icon name="event" class="cursor-pointer">
                    <q-popup-proxy
                      cover
                      transition-show="scale"
                      transition-hide="scale"
                    >
                      <q-date
                        :locale="myLocale"
                        :options="optionsFn"
                        mask="DD/MM/YYYY"
                        v-model="filtros.dataInicial"
                      >
                        <div class="row items-center justify-end">
                          <q-btn
                            v-close-popup
                            label="Fechar"
                            color="primary"
                            flat
                          />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
            </div>

            <div class="col-12 col-md-6">
              <div class="text-brand-5 text-weight-bold q-mb-sm">
                Data Final
              </div>
              <q-input
                dense
                outlined
                placeholder="DD/MM/AAAA"
                v-model="filtros.dataFinal"
                mask="##/##/####"
                :rules="[(val) => validarDataEmissao(val) || 'Data Inválida']"
              >
                <template v-slot:append>
                  <q-icon name="event" class="cursor-pointer">
                    <q-popup-proxy
                      cover
                      transition-show="scale"
                      transition-hide="scale"
                    >
                      <q-date
                        :locale="myLocale"
                        :options="optionsFn"
                        mask="DD/MM/YYYY"
                        v-model="filtros.dataFinal"
                      >
                        <div class="row items-center justify-end">
                          <q-btn
                            v-close-popup
                            label="Fechar"
                            color="primary"
                            flat
                          />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
            </div>

            <div class="col-12 col-md-6">
              <div
                class="text-brand-5 text-weight-bold q-mb-sm campo-filtro-top"
              >
                Centro de Custo
              </div>
              <q-input
                dense
                outlined
                v-model="filtros.centroCusto"
                type="number"
                placeholder="Digite o ID do centro de custo"
              />
            </div>

            <div class="col-12 col-md-6">
              <div
                class="text-brand-5 text-weight-bold q-mb-sm campo-filtro-top"
              >
                Produto (Código ou Descrição)
              </div>
              <q-input
                dense
                outlined
                v-model="filtros.produto"
                placeholder="Digite código ou descrição do produto"
              />
            </div>

            <div class="col-12 col-md-6">
              <div class="text-brand-5 text-weight-bold q-mb-sm">
                Grupos de Produto
              </div>
              <q-select
                dense
                outlined
                v-model="filtros.gruposProduto"
                multiple
                use-chips
                :options="gruposOptions"
                option-label="description"
                option-value="id"
                emit-value
                map-options
                use-input
                @filter="filterGrupos"
                label="Selecione os grupos"
              />
            </div>

            <div class="col-12 col-md-6">
              <div class="text-brand-5 text-weight-bold q-mb-sm">
                Categorias de Produto
              </div>
              <q-select
                dense
                outlined
                v-model="filtros.categoriasProduto"
                multiple
                use-chips
                :options="categoriasOptions"
                option-label="description"
                option-value="id"
                emit-value
                map-options
                use-input
                @filter="filterCategorias"
                label="Selecione as categorias"
              />
            </div>

            <div class="col-12 col-md-6">
              <div class="text-brand-5 text-weight-bold q-mb-sm">
                Tipo de Fornecimento
              </div>
              <q-select
                dense
                outlined
                v-model="filtros.tipoFornecimento"
                multiple
                use-chips
                :options="suppliesOptions"
                option-label="name"
                option-value="id"
                emit-value
                map-options
                use-input
                @filter="filterSupplies"
                label="Selecione os tipos"
              />
            </div>

            <div class="col-12 col-md-6">
              <div class="text-brand-5 text-weight-bold q-mb-sm">Status</div>
              <q-select
                dense
                outlined
                v-model="filtros.status"
                :options="statusOptions"
                option-label="label"
                option-value="value"
                emit-value
                map-options
                label="Selecione o status"
              />
            </div>

            <div class="col-12 col-md-6">
              <div class="text-brand-5 text-weight-bold q-mb-sm">
                ID da Requisição
              </div>
              <q-input
                dense
                outlined
                v-model="filtros.requisicaoId"
                type="number"
                placeholder="Digite o ID da requisição"
              />
            </div>
          </div>
        </q-card-section>

        <q-card-actions align="right" class="bg-white text-teal q-pa-md">
          <q-btn
            label="Limpar"
            no-caps
            flat
            color="primary"
            @click="limparFiltros"
          />
          <q-btn
            label="Filtrar"
            :loading="loading"
            no-caps
            icon="filter_alt"
            color="primary"
            @click="aplicarFiltros"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { ref, watch, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { validarDataEmissao } from "../../../helpers/dateValidation";

export default {
  props: ["loadingValue"],
  setup(props, { emit }) {
    const store = useStore();
    const route = useRoute();
    const loading = ref(false);
    const abrirModal = ref(
      route.params.id != "" &&
        route.params.id != undefined &&
        route.params.id != "carregado"
        ? false
        : true
    );
    const persistent = ref(false);
    const id = route.params.id;

    const filtros = ref({
      unidade: {
        id: store.state.org.unidadeData.id,
        label: store.state.org.unidadeData.nome,
      },
      numeroContrato: "",
      dataInicial: "",
      dataFinal: "",
      centroCusto: "",
      produto: "",
      gruposProduto: [],
      categoriasProduto: [],
      tipoFornecimento: [],
      status: "",
      requisicaoId: "",
    });

    const optionsUnidade = ref([]);
    const gruposOptions = ref([]);
    const categoriasOptions = ref([]);
    const suppliesOptions = ref([]);

    const statusOptions = [
      { label: "Ativo", value: "active" },
      { label: "Inativo", value: "inactive" },
      { label: "Encerrado", value: "finished" },
      { label: "Cancelado", value: "canceled" },
    ];

    const myLocale = {
      days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
      daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
      months:
        "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
          "_"
        ),
      monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),
      firstDayOfWeek: 1,
    };

    const optionsFn = (date) => {
      const hoje = new Date();
      const ontem = new Date(hoje.getTime());
      ontem.setDate(hoje.getDate());

      const dd = ontem.getDate();
      const mm = ontem.getMonth() + 1;
      const yyyy = ontem.getFullYear();

      const dataFormatada = `${yyyy}/${mm.toString().padStart(2, "0")}/${dd
        .toString()
        .padStart(2, "0")}`;

      return date <= dataFormatada;
    };

    const aplicarFiltros = async () => {
      loading.value = true;

      const dataInicialFormatada = filtros.value.dataInicial
        ? filtros.value.dataInicial.split("/").reverse().join("-")
        : undefined;
      const dataFinalFormatada = filtros.value.dataFinal
        ? filtros.value.dataFinal.split("/").reverse().join("-")
        : undefined;

      const filtrosFormatados = {
        vendors: filtros.value.unidade?.id
          ? [filtros.value.unidade.id]
          : undefined,
        contractNumber: filtros.value.numeroContrato || undefined,
        startDate: dataInicialFormatada,
        endDate: dataFinalFormatada,
        costCenterId: filtros.value.centroCusto
          ? parseInt(filtros.value.centroCusto)
          : undefined,
        product: filtros.value.produto || undefined,
        productGroups:
          filtros.value.gruposProduto.length > 0
            ? filtros.value.gruposProduto
            : undefined,
        productCategories:
          filtros.value.categoriasProduto.length > 0
            ? filtros.value.categoriasProduto
            : undefined,
        supplies:
          filtros.value.tipoFornecimento.length > 0
            ? filtros.value.tipoFornecimento
            : undefined,
        status: filtros.value.status || undefined,
        voucherId: filtros.value.requisicaoId
          ? parseInt(filtros.value.requisicaoId)
          : undefined,
      };

      emit("filtrar", filtrosFormatados, filtros.value);
    };

    const limparFiltros = () => {
      filtros.value = {
        unidade: {
          id: store.state.org.unidadeData.id,
          label: store.state.org.unidadeData.nome,
        },
        numeroContrato: "",
        dataInicial: "",
        dataFinal: "",
        centroCusto: "",
        produto: "",
        gruposProduto: [],
        categoriasProduto: [],
        tipoFornecimento: [],
        status: "",
        requisicaoId: "",
      };
    };

    const listarUnidades = async () => {
      try {
        const response = await store.dispatch("org/listarUnidades");
        let array = response.listaUnidades;
        array.forEach((unidade) => {
          optionsUnidade.value.push({
            label: unidade.nome,
            id: unidade.id,
          });
        });
      } catch (error) {
        console.log(error);
      }
    };

    const filterGrupos = async (val, update) => {
      if (val === "") {
        update(() => {
          gruposOptions.value = [];
        });
        return;
      }

      try {
        const response = await store.dispatch("compras/getGrupos", {
          vendor_id: store.state.org.unidadeData.id,
          search: val,
          page: 1,
        });
        update(() => {
          gruposOptions.value = response.data.results.data || [];
        });
      } catch (error) {
        console.error("Erro ao carregar grupos:", error);
        update(() => {
          gruposOptions.value = [];
        });
      }
    };

    const filterCategorias = async (val, update) => {
      if (val === "") {
        update(() => {
          categoriasOptions.value = [];
        });
        return;
      }

      try {
        const response = await store.dispatch("compras/getCategorias", {
          vendor_id: store.state.org.unidadeData.id,
          search: val,
          page: 1,
        });
        update(() => {
          categoriasOptions.value = response.data.results.data || [];
        });
      } catch (error) {
        console.error("Erro ao carregar categorias:", error);
        update(() => {
          categoriasOptions.value = [];
        });
      }
    };

    const filterSupplies = async (val, update) => {
      if (val === "") {
        update(() => {
          suppliesOptions.value = [];
        });
        return;
      }

      try {
        const response = await store.dispatch("gdcStore/getSupplies", {
          name: val,
        });
        update(() => {
          suppliesOptions.value = response.data.result.data || [];
        });
      } catch (error) {
        console.error("Erro ao carregar tipos de fornecimento:", error);
        update(() => {
          suppliesOptions.value = [];
        });
      }
    };

    watch(
      () => props.loadingValue,
      () => {
        loading.value = props.loadingValue;
        if (loading.value == false) {
          setTimeout(() => {
            abrirModal.value = false;
            persistent.value = false;
          }, 1000);
        }
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        filtros.value.unidade = {
          id: store.state.org.unidadeData.id,
          label: store.state.org.unidadeData.nome,
        };
      }
    );

    const verificarPersistencia = async () => {
      if (id) {
        persistent.value = false;
      }
    };

    onMounted(verificarPersistencia);
    onMounted(listarUnidades);

    return {
      abrirModal,
      filtros,
      loading,
      persistent,
      optionsUnidade,
      gruposOptions,
      categoriasOptions,
      suppliesOptions,
      statusOptions,
      myLocale,
      optionsFn,
      aplicarFiltros,
      limparFiltros,
      validarDataEmissao,
      filterGrupos,
      filterCategorias,
      filterSupplies,
    };
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.text-brand-5 {
  font-size: 14px;
}

:deep(.q-field--dense .q-field__control) {
  min-height: 40px;
}

.q-mb-sm {
  margin-bottom: 8px;
}

.campo-filtro-top {
  margin-top: -16px;
}
</style>
